import en from './en/en';

export default {
    ...en,
};
